import React from 'react';
import classNames from 'classnames';

const FormText = ({ id, className, children, ...props }) => {
  return (
    <div id={id} className={classNames('form-text', className)} {...props}>
      {children}
    </div>
  );
};

export default FormText;
